import { Typography } from '@mui/material';
import { bool, string } from 'prop-types';
import React, { memo } from 'react';

const EmployeeLabel = ({ right, children = null }) => {
  if (!children) return null;
  return (
    <Typography
      align="center"
      variant="caption"
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-end',
        paddingTop: '15px',
        paddingLeft: '45px',
        ...(right && {
          flexDirection: 'row-reverse',
          alignSelf: 'flex-end',
          paddingRight: '45px',
        }),
      }}
    >
      <span>
        <strong>{children}</strong>
      </span>
    </Typography>
  );
};

EmployeeLabel.propTypes = {
  children: string,
  right: bool.isRequired,
};

export default memo(EmployeeLabel);
